/**
 * Copyright (c) Streamlit Inc. (2018-2022) Snowflake Inc. (2022-2025)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// Note: Cached themes before version 1 were simply stored with key equal to
// CACHED_THEME_BASE_KEY (with no version number).
const CACHED_THEME_VERSION = 1
const CACHED_THEME_BASE_KEY = `stActiveTheme-${window.location.pathname}`

export const LocalStore = {
  CACHED_THEME_VERSION,
  CACHED_THEME_BASE_KEY,

  ACTIVE_THEME: `${CACHED_THEME_BASE_KEY}-v${CACHED_THEME_VERSION}`,
}
